module.exports = __webpack_public_path__ + "images/help_v2/video-members-72cfe15bf4d1d1ad74ec3abf70b2b04c.jpg";